import * as angular from 'angular';
import 'angular-route';
import 'angular-animate';
import 'angular-sanitize';
import 'angular-local-storage';
import 'angular-loading-bar';
import 'angular-ui';
import 'angular-bootstrap-toggle';
import 'ng-showdown';
import 'oclazyload';
import { gpCommon } from '../app-common/app';
import { gpDataApp } from '../app-data/app';

export const gpHome = angular.module("gamePlanHomeApp",
    [
        'ngRoute',
        'ngAnimate',
        'ng-showdown',
        'angular-loading-bar',
        'ui.bootstrap',
        gpCommon.name,
        gpDataApp.name,
        'oc.lazyLoad',
    ]);
